
import React from 'react';
import {getRGB, multWhite} from "../../../lib/color";

const FONT_STYLE = {
  fontFamily: "avenir-lt, sans-serif",
  fontSize: "1.1rem",
  fontWeight: "bold",
}

const render_button = (label, id, _style, component, cb) => {

  const style = {
    cursor: "pointer",
    padding: "0.5rem 1.4rem",
    border: "solid 1px black",
    ...FONT_STYLE,
    ..._style,
  }
  const on_mouse_enter = (enter, id) => () => {
    component.setState({
      ["header_button_" + id]: enter,
    })
  }
  return (
    <div>
      <div style={style}
           onClick={cb}
           onMouseEnter={on_mouse_enter(true, id)}
           onMouseLeave={on_mouse_enter(false, id)}>
        { label }
      </div>
    </div>
  )
}

const SignInOut = props => {

  const component = props.component;
  const container_style = {
    display: "flex",
    marginTop: "1rem",
  }
  //const acct_mouse_over = component.state.header_button_create_account;
  /*const acct_bg_color = getRGB(
    multWhite(
      component.props.client.color.sign_on_button,
      acct_mouse_over ? 0.4: 0));*/

  const sign_in_mouse_over = component.state.header_button_sign_in;
  const sign_in_bg_color = getRGB(
    multWhite(
      { r: 0, g: 0, b: 0 },
      sign_in_mouse_over ? 0.4 : 0));

  const on_sign_in = () => {
    component.props.navigatePath("/login");
  }
  /*const on_new_acct = () => {
    component.props.navigatePath("/new_account");
  }*/
  return (
    <div style={container_style}>
      { render_button("Sign In", "sign_in", {
        backgroundColor: sign_in_bg_color,
        color: "white",
      }, component, on_sign_in)}
      <div style={{ width: "1rem"}}/>
      { /*render_button("Create an Account", "create_account", {
        backgroundColor: acct_bg_color,
        color: "black",
      }, component, on_new_acct) */}
    </div>
  )
}

export { SignInOut };
